export default {"src":"/_next/static/media/TongueTieRelease.0e222f56.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};